import background from "../media/images/gray5.jpg";
import first from "../media/images/first.jpg";
import second from "../media/images/second.jpg";
import third from "../media/images/third.jpg";
import fourth from "../media/images/fourth2.jpg";
import fifth from "../media/images/fifth.jpg";
import "./Home.css";
import image2 from "../media/images/Untitled-2.jpg";
import 'react-slideshow-image/dist/styles.css'
import ImageSlider from "./ImageSlider";
import workstationImg from "../media/images/workstations.jpg";
import trolleystation from "../media/images/trolleys.jpg";
import flowtrack from "../media/images/flowrack.jpg";
import EmblaCarousel from "../components/Carausel";
import workBlock from "../media/images/workB.jpg";
import flowB from "../media/images/flowB.jpg";
import crateB from "../media/images/cratelifterB.jpg";
import karakuri from "../media/images/karakuriB.jpg";
import cB from "../media/images/blockC.jpg";
import leanBlock from "../media/images/leanBlock2.jpg";
import appBlock from "../media/images/appBlocj2.jpg";
import firstC from "../media/images/trolleys2.jpg";
import secondC from "../media/images/secondC.jpg";
import thirdC from "../media/images/thirdC.jpg";
import fourthC from "../media/images/fourthC.jpg";
import fifthC from "../media/images/fifthC.jpg";
import karakuriP from "../media/images/karakuri.png";
import ass from "../media/images/assembly(1).png";
import packing from "../media/images/packing.png";
import { useNavigate } from "react-router";
import sixC from "../media/images/sixCjpg.jpg";
import sevenC from "../media/images/sevenC.png";
import eightC from "../media/images/eightC.png";
import nineC from "../media/images/nineC.jpg";
import tenC from "../media/images/tenC.jpg";

const Home = () => {
        const handleDownload = (name) => {
        const pdfUrl = "/"+name+".pdf";
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = name+".pdf"; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
    const slidesData = [
  { id: 0, title: 'Workstations',imageUrl: workstationImg},
  { id: 1, title: 'Trolleys',imageUrl: trolleystation},
  { id: 2, title: 'Flow Racks',imageUrl: flowtrack},
  { id: 3, title: 'Karakuri Systems',imageUrl: karakuriP},
  { id: 4, title: 'Assembly Lines',imageUrl: ass},
  { id: 5, title: 'Packing Tables',imageUrl: packing},
];
    const slidesData2=[
        {id:0, title:"",imageUrl:firstC},
        {id:1, title:"",imageUrl:secondC},
        {id:3, title:"",imageUrl:fourthC},
        {id:7, title:"",imageUrl:eightC},
        {id:4, title:"",imageUrl:fifthC},
        {id:5, title:"",imageUrl:sixC},
        {id:6, title:"",imageUrl:sevenC},
        {id:2, title:"",imageUrl:thirdC},
        {id:8, title:"",imageUrl:nineC},
        {id:9, title:"",imageUrl:tenC},
    ]
    const slideSlike=[
        {slika:first, textU1:"Adaptable Design", textU2:"Reliable Safety", textU3:"",textD:"MACHINE'S CASINGS"},
        {slika:fifth, textU1:"Make your shop floor smarter", textU2:"safer, and more efficient", textU3:"", textD:"TROLLEYS"},
        {slika:third, textU1:"Reduce packing errors with", textU2:"organized, ergonomic layouts",textU3:"", textD:"PACKING TABLES"},
        {slika:fourth, textU1:"Custom, ergonomic, efficient", textU2:"", textU3:"", textD:"WORKSTATIONS"},
        {slika:second, textU1:"Optimmize your", textU2:"assembly workflow",textU3:"", textD:"ASSEMBLY LINES"},
    ];
    const navigate = useNavigate();
    return ( 
        <div className="home">
            <div className="bPage">
                <ImageSlider images={slideSlike}/>
                <img src={background} alt="d" className="bImage"/>
            </div>
            <div className="phoneB">
                <img src={background} alt="d"/>
            </div>
            <div className="nextBlock">
                <div className="blockText">
                    <div className="bigText">
                        <p >LEAN</p>
                        <p >PRODUCTION & MATERIAL</p>
                        <p >FLOW SYSTEMS</p>     
                    </div>
                    <div className="smallText">
                        <p >
                            With Ecomode Studio you enter the world of advanced lean production.
                            We engineer and implement efficient, flexible, and safe manufacturing 
                            systems while optimizing processes, material flow, ergonomics, and 
                            workplace design-creating scalable solutions.
                        </p>
                    </div>
                </div>
                <div className="blockImage">
                    <img src={image2} alt=""/>
                </div>
            </div>
            <div className="CarauselBlock" id="lean">
                <h1> Lean Manufacturing Solutions</h1>
                <EmblaCarousel slidesData={slidesData} vC={3}/>
            </div>
            <div className="detailsBlock">
                <img onClick={()=>navigate("/flowracks")} src={flowB} alt="d"/>
                <img onClick={()=>navigate("/cratelifter")} src={crateB} alt="d"/>
                <img onClick={()=>navigate("/karakuri")} src={karakuri} alt="d"/>
                <img onClick={()=>navigate("/workstations")}src={workBlock} alt="d"/>
            </div>
            <div className="detailsBlock2">
                <img onClick={()=>navigate("/flowracks")} src={flowB} alt="d"/>
                <img onClick={()=>navigate("/cratelifter")} src={crateB} alt="d"/>
            </div>
            <div className="detailsBlock3">
                <img onClick={()=>navigate("/karakuri")} src={karakuri} alt="d"/>
                <img onClick={()=>navigate("/workstations")}src={workBlock} alt="d"/>
            </div>
            <div className="contentBlock" id="service">
                <img src={cB} alt="s"/>
            </div>
            <div className="leanBlock" id="modular">
                <button className="leanButton" onClick={()=>handleDownload('Lean Tube')}>DOWNLOAD LEAN PIPE CATALOG</button>
                <img src={leanBlock} alt="s"/>
                <button className="karakuriButton" onClick={()=>handleDownload('Aluminium Profile')}>DOWNLOAD KARAKURI CATALOG</button>
            </div>
            <div className="appBlock" id="application">
                <img src={appBlock} alt="ap"/>
            </div>
            <div className="appCarauselBlock">
                <EmblaCarousel slidesData={slidesData2} vC={4}/>
            </div>
            <div className="contactBlock">
                <p>©Ecomode Studio 2025 - All Rights reserved</p>
            </div>
        </div>
     );
}
 
export default Home;